import { useMutation } from "react-query";
import { axiosPost } from "../../lib/axiosClient";

const useDeleteLesson = () => {
  return useMutation((lessonId) => {
    return axiosPost("/api/cw/deleteLesson", lessonId);
  });
};

export default useDeleteLesson;
